import { Grid, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import i18n from 'i18n'

interface PopupSectionTitleProps {
  simplified?: boolean
}

export const PopupSectionTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'simplified'
})<PopupSectionTitleProps>(({ theme, simplified }) => ({
  fontSize: simplified ? '10px' : '11px',
  lineHeight: simplified ? '14px' : '16px',
  fontWeight: simplified ? 400 : 700,
  color: simplified ? theme.palette.text.secondary : theme.palette.text.primary,
  textTransform: 'uppercase'
}))

export const PopupSectionContent = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column'
}))

export const PopupSectionRow = styled(Grid)(({ color, theme }) => ({
  width: '100%',
  display: 'flex',
  flexWrap: 'nowrap',
  alignItems: 'center',

  fontSize: 14,
  color: theme.palette.text.primary,

  '& > div': {
    display: 'flex',
    alignItems: 'center'
  },

  '&[data-onlytitle="true"]': {
    '& > div': {
      width: '100%'
    },
    '& span[data-content="title"]': {
      width: '100%',
      fontWeight: 400
    }
  },

  '& span[data-content="icon"]': {
    height: 16,
    fontSize: '0.625rem',
    minWidth: '42px',
    fontWeight: 400,
    color: theme.palette.input.placeholder
  },
  '& span[data-content="icon-small"]': {
    height: 12,
    fontSize: '0.625rem',
    minWidth: '42px',
    fontWeight: 400,
    color: theme.palette.input.placeholder,
    margin: theme.spacing(0, 3, 0, 0)
  },
  '& span[data-content="icon-regular"]': {
    height: 20,
    fontSize: '0.625rem',
    width: 20,
    maxWidth: 20,
    fontWeight: 400,
    color: theme.palette.input.placeholder,
    margin: theme.spacing(
      0,
      i18n.dir() === 'ltr' ? 3 : 0,
      0,
      i18n.dir() === 'rtl' ? 3 : 0
    )
  },
  '& span[data-content="icon-xs"]': {
    height: 16,
    fontSize: '0.625rem',
    width: 16,
    maxWidth: 16,
    fontWeight: 400,
    color: theme.palette.input.placeholder,
    margin: theme.spacing(
      0,
      i18n.dir() === 'ltr' ? 1.5 : 0,
      0,
      i18n.dir() === 'rtl' ? 1.5 : 0
    )
  },
  '& span[data-content="icon-big"]': {
    height: 24,
    fontSize: '0.625rem',
    width: 24,
    minWidth: '42px',
    fontWeight: 400,
    color: theme.palette.input.placeholder
  },
  '& span[data-content="action"]': {
    color: color
  },

  '&[data-hasactionbg="true"] span[data-content="action"]': {
    backgroundColor: 'transparent',
    transition: 'background-color 150ms ease'
  },

  '&[data-hasactionbg="true"] span[data-content="action"]:hover': {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.14)'
        : theme.palette.surface.hover
  }
}))

export const PopupSection = styled(Grid)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.input.placeholder
}))
